import React, { useCallback, useState } from 'react';

import DeclineOrCancelModal from '../../OrderDetail/components/DeclineOrCancelModal';

import { BuyerModal } from './Modal';

import Banner from '@components/Banner';
import { AvailableBanners } from '@components/Banner/constants';
import { useSnackbar } from '@components/Snackbar/hooks';
import { ORDER_TYPE } from '@config/api/task/interface';
import { useAppDispatch } from '@hooks/state';
import useGoogleTagManager from '@hooks/useGoogleTagManager';
import {
  realTimeRefreshAvailabilityOrders,
  saveNewCustomerRequest,
} from '@state/task/actions';
import { assembleOrderBannerGTMEvent } from '@utils/GoogleTagManager';
import { GOOGLE_TAG_MANAGER_EVENT_MESSAGES } from '@utils/GoogleTagManager/interface';

const NewCustomerBanner = ({
  orderId,
  userId,
}: {
  orderId: string;
  userId: number;
}) => {
  const dispatch = useAppDispatch();
  const { showMessage } = useSnackbar();
  const { setGTMEvent } = useGoogleTagManager();
  const [openCashBuyerModal, setOpenCashBuyerModal] = useState<boolean>(false);
  const [openDeclineOrCancelModal, setOpenDeclineOrCancelModal] =
    useState<boolean>(false);
  const [openAccountBuyerModal, setOpenAccountBuyerModal] =
    useState<boolean>(false);

  const gtmEvent = (event: GOOGLE_TAG_MANAGER_EVENT_MESSAGES) =>
    setGTMEvent(
      assembleOrderBannerGTMEvent(event, { orderDetail: { orderId } }),
    );

  const openCashBuyer = () => {
    gtmEvent(GOOGLE_TAG_MANAGER_EVENT_MESSAGES.CLICKED_ON_CASH_BUYER);
    toggleCashBuyerModal();
  };

  const openAccountBuyer = () => {
    gtmEvent(GOOGLE_TAG_MANAGER_EVENT_MESSAGES.CLICKED_ON_ACCOUNT_BUYER);
    toggleAccountBuyerModal();
  };

  const openDeclineOrCancel = () => {
    gtmEvent(GOOGLE_TAG_MANAGER_EVENT_MESSAGES.CLICKED_ON_DECLINE);
    togleDeclineOrCancel();
  };

  const toggleCashBuyerModal = () => setOpenCashBuyerModal(!openCashBuyerModal);
  const toggleAccountBuyerModal = () =>
    setOpenAccountBuyerModal(!openAccountBuyerModal);
  const togleDeclineOrCancel = () =>
    setOpenDeclineOrCancelModal(!openDeclineOrCancelModal);

  const refreshAvailabilityOrders = () =>
    dispatch(
      realTimeRefreshAvailabilityOrders({
        type: ORDER_TYPE.AVAILABILITY_REQUESTS,
        page: 1,
      }),
    );

  const showSuccessToastMessage = (isAccountBuyer: boolean) => {
    if (isAccountBuyer) toggleAccountBuyerModal();
    else toggleCashBuyerModal();

    refreshAvailabilityOrders();
    showMessage('Successfully added!', {
      severity: 'success',
      autoHide: true,
    });
  };

  const showErrorToastMessage = () =>
    showMessage('Oops, something happened, please try again later!', {
      severity: 'error',
      autoHide: true,
    });

  const handleSaveAction = (
    customTagValue: string,
    isAccountBuyer: boolean,
  ) => {
    dispatch(
      saveNewCustomerRequest({
        userId,
        orderId,
        customTag: customTagValue,
        cashBuyer: !isAccountBuyer,
        successCallback: () => showSuccessToastMessage(isAccountBuyer),
        errorCallback: showErrorToastMessage,
      }),
    );
  };

  const bannerProps = AvailableBanners.newCostumerWarning;
  const [button1, button2, button3] = bannerProps.buttons;
  button1.onPress = openCashBuyer;
  button2.onPress = openAccountBuyer;
  button3.onPress = openDeclineOrCancel;

  const renderModal = useCallback(() => {
    if (openCashBuyerModal)
      return (
        <BuyerModal
          title='Enter Custom Tag'
          subTitle='OPTIONAL'
          open={openCashBuyerModal}
          onClose={toggleCashBuyerModal}
          handleSaveAction={handleSaveAction}
          isLoading={false}
          isAccountBuyer={false}
        />
      );

    if (openAccountBuyerModal)
      return (
        <BuyerModal
          title='Enter Custom Tag'
          subTitle='OPTIONAL'
          open={openAccountBuyerModal}
          onClose={toggleAccountBuyerModal}
          handleSaveAction={handleSaveAction}
          isLoading={false}
          isAccountBuyer
        />
      );

    if (openDeclineOrCancelModal)
      return (
        <DeclineOrCancelModal
          orderId={String(orderId)}
          onClose={togleDeclineOrCancel}
          isOpen={openDeclineOrCancelModal}
        />
      );

    return null;
  }, [openCashBuyerModal, openAccountBuyerModal, openDeclineOrCancelModal]);

  return (
    <>
      {renderModal()}
      <Banner {...bannerProps} buttons={[button1, button2, button3]} />
    </>
  );
};

export default NewCustomerBanner;
